import My from "../views/layout.vue";

const routes = [
  {
    path: "/",
    name: "map",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "home",
    component: My,
    children: [
      {
        path: "/chat-online",
        name: "Homepage",
        component: () => import("@views/home/index.vue"),
        meta: {
          title: "云直播",
        },
      },
      {
        path: "/auth",
        name: "Homepage1",
        component: () => import("@views/home/auth.vue"),
        meta: {
          title: "云直播",
        },
      },
      {
        path: "/feedback",
        name: "Homepage2",
        component: () => import("@views/home/feedback.vue"),
        meta: {
          title: "意见反馈",
        },
      },
      {
        path: "/complain",
        name: "Homepage3",
        component: () => import("@views/home/complain.vue"),
        meta: {
          title: "投诉",
        },
      },
      {
        path: "/mine",
        name: "Homepage4",
        component: () => import("@views/home/mine.vue"),
        meta: {
          title: "我的",
        },
      },
      {
        path: "/entry",
        name: "entry",
        component: () => import("@views/entry/index.vue"),
        meta: {
          title: "入口",
        },
      }
    ],
    redirect: "/auth",
  },
];

export default routes;
